export default {
  id: "jumprope-mach10",
  pride: 8192,
  slug: "jumprope-mach10",
  category: "video",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "跳绳，但速度是10马赫",
    en: "Jump Rope at Mach 10"
  },
  bilibiliVideoId: "BV1Qi4y1f7k1",
  descriptionKey: {
    zh: "随手做的热点视频，279.7万播放。不是我的主要方向。",
    en: "A casual trending video. 2.797M views. Not my main direction."
  },
  date: { year: 2022, month: 2, day: 14 },
  genres: ["热点", "搞笑"],
  themes: ["物理", "脑洞"],
  achievements: [
    { zh: "279.7 万播放", en: "2.797M views" }
  ],
  developerNotesKey: {
    zh: "随手做的热点视频，不是我的主要方向。",
    en: "Casual trending video, not my main direction."
  },
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1Qi4y1f7k1/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
